import { OnboardingStep } from '@app/shared/onboarding/onboarding-checklist.model';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

import { OnboardingStepConfig } from './onboarding.model';

export interface OnboardingStoreState {
  step: OnboardingStep;
  config?: OnboardingStepConfig;
}

const initialState: OnboardingStoreState = {
  step: null,
};

export const OnboardingStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    updateState(step: OnboardingStep, config?: OnboardingStepConfig): void {
      patchState(store, { step, config });
    },
  })),
);
